import React            from 'react'
import Link             from 'gatsby-link'
import createReactClass from 'create-react-class'
import Img              from 'gatsby-image'

import Header from '../components/header'

import itsu             from '../static/itsu.png'
import carolina_herrera from '../static/carolina_herrera.png'
import sparta           from '../static/sparta.png'
import esartia          from '../static/esartia.png'
import skaled           from '../static/skaled.png'
import care             from '../static/careandwear.png'
import vision           from '../static/vision42.png'
import starship         from '../static/100yss.png'

let portfolio_data = [
  {
    img: itsu,
    title: 'Itsu',
    tags: ['ES6', 'SASS/CSS', 'Ruby on Rails', 'Redis', 'Google Maps API', 'MySQL'],
    link: 'https://www.itsu.com/'
  },
  {
    img: carolina_herrera,
    title: 'Carolina Herrera',
    tags: ['ES6', 'jQuery', 'SASS/CSS', 'WordPress'],
    link: 'https://www.carolinaherrera.com/'
  },
  {
    img: sparta,
    title: 'Sparta',
    tags: ['ES6', 'SASS/CSS', 'React', 'Redux'],
    link: 'http://cesartia.com/sparta-test/'
  },
  {
    img: esartia,
    title: 'Esartia',
    tags: ['ES6', 'Meteor', 'SASS/CSS', 'Mailgun'],
    link: 'http://esartia.com/'
  },
  {
    img: skaled,
    title: 'Skaled',
    tags: ['ES6', 'GSAP', 'jQuery', 'SASS/CSS'],
    link: 'https://skaled.com'
  },
  {
    img: care,
    title: 'Careandwear',
    tags: ['ES6', 'Angular', 'SASS/CSS', 'Node.js'],
    link: 'https://www.careandwear.com'
  },
  {
    img: vision,
    title: 'Vision42',
    tags: ['ES6', 'SASS/CSS', 'Rails'],
    link: 'http://vision42.org'
  },
  {
    img: starship,
    title: '100yearstarship',
    tags: ['ES6', 'SASS/CSS', 'Rails'],
    link: 'http://100yss.org'
  }
]

const PortfolioPage = createReactClass({
  render() {
    return (
      <div style={{height:'100%', width: '100%'}}>
        <Header />
        <main className="t__portfolio">
          { portfolio_data.map( item => {
              return (
                <div className="m__portfolio-item">
                  <img src={item.img} />
                  <a href={item.link}>{item.title}</a>

                  <aside>
                    <div>
                      { item['tags'].map( tag => {
                        return(
                          <span>{tag}</span>
                        )
                      })}
                    </div>
                  </aside>
                </div>
              )
            })
          }
        </main>
      </div>
    )
  }
})

export default PortfolioPage


// WEBPACK FOOTER //
// ./src/pages/portfolio.js